import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "src", "background", "altText", "gatsbyImageProps", "children", "className", "loadStrategy", "style", "imgStyle"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import BackgroundImage from 'gatsby-background-image';
import Img from 'gatsby-image';
import { ChildrenPropType, StylePropType } from '../../../../services/proptypes';
import { getOldImage } from '../../../../utils/gatsby';
import { EAGER_LOAD_STRATEGY, IMAGE_LOAD_STRATEGIES, LAZY_LOAD_STRATEGY } from '../../Image.constants';
import { getGatsbyImageStyle } from '../../Image.utils';
var defaultProps = {
  as: 'div',
  src: '',
  background: false,
  altText: '',
  gatsbyImageProps: null,
  children: null,
  className: '',
  loadStrategy: LAZY_LOAD_STRATEGY,
  style: {},
  imgStyle: {}
};
export default function ImageOld(_ref) {
  var as = _ref.as,
    src = _ref.src,
    background = _ref.background,
    altText = _ref.altText,
    gatsbyImageProps = _ref.gatsbyImageProps,
    children = _ref.children,
    className = _ref.className,
    loadStrategy = _ref.loadStrategy,
    style = _ref.style,
    imgStyle = _ref.imgStyle,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var imageData = getOldImage(src);
  var allStyles = _objectSpread(_objectSpread({}, style || {}), imgStyle || {});
  var allGatsbyImageProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, extraProps), gatsbyImageProps), imageData), {}, {
    alt: altText,
    className: "legacy-gatsby-image ".concat(className)
  });
  var isEager = loadStrategy === EAGER_LOAD_STRATEGY;
  if (background) {
    return /*#__PURE__*/React.createElement(BackgroundImage, _extends({}, allGatsbyImageProps, {
      Tag: as,
      critical: isEager,
      style: allStyles
    }), children);
  }
  var _getGatsbyImageStyle = getGatsbyImageStyle(allStyles),
    parentStyles = _getGatsbyImageStyle.parentStyles,
    childStyles = _getGatsbyImageStyle.childStyles;
  return /*#__PURE__*/React.createElement(Img, _extends({}, allGatsbyImageProps, {
    loading: loadStrategy,
    style: parentStyles,
    imgStyle: childStyles
  }));
}
ImageOld.defaultProps = defaultProps;